import React from 'react'
import Title from '../common/title'

const WsdForm = ({ serviceData }) => {
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Add console log for debugging
        console.log('Form submission started');
        
        const formData = new FormData(e.target);
        const redirectUrl = "https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-7483f437fe224b46acfcb1b7b9a39e70b26786ae646c440f8e5530dddc8fc0bfa084bdcb3a40451cbf585de1c82ce291?locale=EN_US";
        
        // Log form data for debugging
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        
        try {
            console.log('Sending request to webhook...');
            const response = await fetch('https://hook.us2.make.com/cwejmr1i531raeg4b71vkh3u9arhj31b', {
                method: 'POST',
                body: formData,
                // Remove headers that might cause CORS issues
                mode: 'no-cors' // This might help with CORS issues
            });
            
            console.log('Response:', response);
            console.log('Response status:', response.status);
            console.log('Response ok:', response.ok);
            
            // With no-cors mode, we can't read the response, so we assume success
            if (response.type === 'opaque' || response.ok) {
                console.log('Form submitted successfully, redirecting...');
                // Small delay before redirect to ensure request completes
                setTimeout(() => {
                    window.location.href = redirectUrl;
                }, 100);
            } else {
                console.error('Response not ok:', response.status, response.statusText);
                const responseText = await response.text();
                console.error('Response text:', responseText);
                alert(`Error submitting form: ${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            console.error('Fetch error details:', error);
            console.error('Error name:', error.name);
            console.error('Error message:', error.message);
            alert(`Network error: ${error.message}`);
        }
    };

    // Fallback dates if serviceData is not available
    const fallbackDates = [
        { value: "August 2, 2025", label: "August 2, 2025 @ 1pm" }
    ];

    const availableDates = serviceData?.dates || fallbackDates;
    const serviceName = serviceData?.service_name || "Women's Self Defense";

    return (
        <div className="contact-form-area pb-75">
            <div className="container">
                <Title 
                    sectionName={"Fill out the Form Below"} 
                    sectionTitle={`Sign Up for ${serviceName}`}
                />

                <div className="contact-form-info" data-cue="slideInUp">
                    <form onSubmit={handleSubmit}>
                        
                        <input type="hidden" name="_honey" style={{display: 'none'}} />
                        <input type="hidden" name="_captcha" value="false"/>
                        <input type="hidden" name="form_type" value="WSD" />

                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="first-name" placeholder="First Name" required />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="last-name" placeholder="Last Name" required />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input 
                                        type="email" 
                                        className="form-control" 
                                        name="email" 
                                        placeholder="Email" 
                                        required 
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input 
                                        type="tel" 
                                        className="form-control" 
                                        name="phone" 
                                        placeholder="Phone" 
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <select 
                                        name="options" 
                                        id="options" 
                                        className="form-control" 
                                        defaultValue="" 
                                        required
                                    >
                                        <option value="" disabled>Select a Date</option>
                                        {availableDates.map((date, index) => (
                                            <option key={index} value={date.value}>
                                                {date.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                       
                        <button type="submit">Register and Pay</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default WsdForm